var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 16.9961L0 0V11.0233C1.34139 11.0233 2.55872 10.5388 3.50855 9.74419C4.59407 8.82946 6.09829 8.60465 7.36214 9.24806L22.6175 16.9922L7.36214 24.7364C6.09441 25.3798 4.59407 25.155 3.50855 24.2403C2.55872 23.4419 1.33751 22.9612 0 22.9612V34L34 17V16.9961Z",
    fill: "#050505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepBlack);
export default __webpack_public_path__ + "static/media/step-black.736202f6a472d3c9b04c08e3acd14cc4.svg";
export { ForwardRef as ReactComponent };